import { Component } from '@angular/core';
import { ComponentsModule } from "../../components.module";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-no-validacion-identidad',
  standalone: false,
  templateUrl: './no-validacion-identidad.component.html',
  styleUrl: './no-validacion-identidad.component.scss'
})
export class NoValidacionIdentidadComponent {
  sessionId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

  }
  
  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();
  }

  volverInicio(): void {
    this.router.navigate(['./']);
  }
}
